<template>
  <div class="message-body" :class="[isEmoji(text) ? 'emoji-show' : '', senderType == 'user' ? '' : 'color-theme-default']" v-html="escapedText">
  </div>
</template>

<script>
import linkifyHtml from 'linkifyjs/html'
import { u as umbrella } from 'umbrellajs'
import * as utils from '../utils'
import store from '../store'
import { markdown } from 'markdown'
import _escape from 'lodash/escape'

function isEmoji (text) {
  text = text.trim()
  for (let emo in utils.EMOJI_LIST) {
    if (text === `:${emo}:`) {
      return true
    }
  }

  return false
}

function emoji (value) {
  if (!value) return ''
  value = value.toString()
  // replace emoji
  for (let emo of utils.EMOJI_LIST) {
    let classNames = emo.replace('_', '-')

    // if (!isEmoji(value)) {
    //   classNames += ' small'
    // }

    const re = new RegExp(`:${emo}:`, 'g')
    value = value.replace(re, `<span class="emoji small"><i class="icon-emo ${classNames}"></i></span>`)
  }

  return value
}

export default {
  props: {
    text: String,
    senderType: String,
    created: Number,
    format: String
  },

  methods: {
    isEmoji
  },

  computed: {
    escapedText () {
      let escapedText = ''

      if (this.format === 'html') {
        escapedText = this.text
      } else if (this.format === 'markdown') {
        escapedText = emoji(markdown.toHTML(this.text))
      } else {
        escapedText = emoji(linkifyHtml(_escape(this.text)))
        escapedText = escapedText.replace(/\n/g, '<br />')
      }
      return escapedText + `<div class="show-message-time">${utils.showDateTime(this.created, store.state.dateFormat)}</div>`
    }
  },

  mounted () {
    const el = umbrella(this.$el)
    el.find('a').each((node, i) => {
      umbrella(node).attr('target', '_blank')
    })
  }
}
</script>
